import { cn } from '@/lib/utils';

import WarningIcon from '../icons/warning';

export function ScheduleBadge({ schedule, className, disabled = false }: { schedule: { id: string; name: string }; className?: string; disabled?: boolean }) {
  const badgeClasses = disabled ? 'bg-grey-1 text-default-text hover:bg-default-light-blue/80' : 'bg-default-light-violet text-default-dark-violet';

  return (
    <span className={cn('flex w-fit items-center gap-1 rounded-[5px] p-[2px_5px] text-sm font-semibold', badgeClasses, className)} key={schedule.id}>
      {disabled && <WarningIcon className="text-default-red" />}
      {schedule.name}
    </span>
  );
}
